import PropTypes from 'prop-types';
import React from 'react';
import { BadgeWrapper, A11yText } from './PlayBadge.styles';

export const THEMES = {
    DEFAULT: 'DEFAULT',
    UPCOMING: 'UPCOMING',
    UPCOMING_MEDIUM: 'UPCOMING_MEDIUM',
    OPEN_ARCHIVE_SMALL: 'OPEN_ARCHIVE_SMALL',
    LAST_CHANCE: 'lastChance',
    LIVE: 'live',
    LIVE_MEDIUM: 'LIVE_MEDIUM',
    LIVE_LARGE: 'LIVE_LARGE',
};

export const PlayBadge = ({ text, accessibilityText, theme, className, overlay }) => {
    const ariaHidden = accessibilityText ? true : false;
    const AccessibilityText = accessibilityText ? <A11yText>{accessibilityText}</A11yText> : false;

    return (
        <BadgeWrapper theme={theme} className={className} overlay={overlay}>
            <span aria-hidden={ariaHidden}>{text}</span>
            {AccessibilityText}
        </BadgeWrapper>
    );
};

PlayBadge.propTypes = {
    text: PropTypes.string.isRequired,
    accessibilityText: PropTypes.string,
    theme: PropTypes.oneOf([
        THEMES.DEFAULT,
        THEMES.UPCOMING,
        THEMES.UPCOMING_MEDIUM,
        THEMES.OPEN_ARCHIVE_SMALL,
        THEMES.LAST_CHANCE,
        THEMES.LIVE,
        THEMES.LIVE_MEDIUM,
        THEMES.LIVE_LARGE,
    ]).isRequired,
    overlay: PropTypes.bool,
    className: PropTypes.string,
};

export default PlayBadge;
